import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { Clock, Users, Zap, Shield, BarChart3 } from 'lucide-react';

const DeploymentSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="A phased approach to deploying reasoning models in production NOC"
      >
        Deployment Roadmap
      </SlideTitle>
      
      <SlideContent>
        {/* Timeline */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          {/* Phase 1 */}
          <div className="slide-card border-accent/30">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-accent/20 flex items-center justify-center">
                <span className="text-sm font-mono font-bold text-accent">1</span>
              </div>
              <div>
                <p className="font-heading font-semibold text-foreground">Passive Assistant</p>
                <p className="text-xs text-muted-foreground">Months 1-3</p>
              </div>
            </div>
            
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Model generates recommendations</li>
              <li>• Humans execute all actions</li>
              <li>• Build confidence, collect feedback</li>
              <li>• Identify failure modes</li>
            </ul>
          </div>
          
          {/* Phase 2 */}
          <div className="slide-card border-chart-4/30">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-chart-4/20 flex items-center justify-center">
                <span className="text-sm font-mono font-bold text-chart-4">2</span>
              </div>
              <div>
                <p className="font-heading font-semibold text-foreground">Active Co-Pilot</p>
                <p className="text-xs text-muted-foreground">Months 4-6</p>
              </div>
            </div>
            
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Auto-execute low-risk actions</li>
              <li>• Human approval for high-risk</li>
              <li>• A/B test vs human-only</li>
              <li>• Continuous improvement</li>
            </ul>
          </div>
          
          {/* Phase 3 */}
          <div className="slide-card border-primary/30">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                <span className="text-sm font-mono font-bold text-primary">3</span>
              </div>
              <div>
                <p className="font-heading font-semibold text-foreground">Autonomous Agent</p>
                <p className="text-xs text-muted-foreground">Months 7+</p>
              </div>
            </div>
            
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Handle routine incidents end-to-end</li>
              <li>• Humans handle edge cases</li>
              <li>• Continuous monitoring</li>
              <li>• Feedback loop for improvement</li>
            </ul>
          </div>
        </div>
        
        {/* ROI Calculation */}
        <div className="slide-card">
          <div className="flex items-center gap-2 mb-4">
            <BarChart3 className="w-5 h-5 text-accent" />
            <span className="font-heading font-semibold text-foreground">ROI Calculation</span>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div>
              <p className="text-sm text-muted-foreground mb-2">Current State</p>
              <p className="text-foreground">100 incidents/month</p>
              <p className="text-foreground">2 hours avg resolution</p>
              <p className="text-muted-foreground">Cost: <span className="font-mono text-destructive">$15,000/mo</span></p>
            </div>
            
            <div>
              <p className="text-sm text-muted-foreground mb-2">With Reasoning Model</p>
              <p className="text-foreground">70 auto-resolved (30 min)</p>
              <p className="text-foreground">30 need human (1.5 hr)</p>
              <p className="text-muted-foreground">Cost: <span className="font-mono text-accent">$8,010/mo</span></p>
            </div>
            
            <div className="p-4 rounded-lg bg-accent/10 border border-accent/30">
              <p className="text-sm text-muted-foreground mb-2">Savings</p>
              <p className="font-heading text-2xl font-bold text-accent">$83,880/year</p>
              <p className="text-sm text-muted-foreground mt-1">ROI: <span className="text-accent">87%</span> after infrastructure</p>
            </div>
          </div>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default DeploymentSlide;
